import { customFetchWithToken } from './services/jwt'

import RestClient from './services/restClient'

import conf from './conf'

export const authClient = new RestClient(conf.SERVER.authURL, fetch, null)
export const authClientRequiredToken = new RestClient(
  conf.SERVER.authURL,
  customFetchWithToken,
  'app.user.token',
  null,
  null,
)

export const orgChartClient = new RestClient(conf.SERVER.orgChartURL, fetch, null)

export const orgChartClientRequiredToken = new RestClient(
  conf.SERVER.orgChartURL,
  customFetchWithToken,
  'app.user.token',
  null,
  'app.user.workspace_id',
)

export const logoClient = new RestClient(conf.SERVER.logoApiURL, fetch, null)

export const officeNextClient = new RestClient(
  conf.SERVER.officeNextURL,
  window.fetch,
  'app.user.providerToken',
  (token) => {
    return {
      key: 'authorization',
      value: `Bearer ${token}`,
    }
  },
  'app.user.workspace_id',
)

export const safeboxClient = new RestClient(
  conf.SERVER.safeboxURL,
  customFetchWithToken,
  'app.user.token',
  null,
  'app.user.workspace_id',
)

export const safeboxClientNoToken = new RestClient(
  conf.SERVER.safeboxURL,
  fetch,
  null,
  null,
  'app.user.workspace_id',
)

export const restClient0 = new RestClient(
  '',
  customFetchWithToken,
  'app.user.token',
  null,
  'app.user.workspace_id',
)
